import Vue from 'vue'
import { ValidationProvider, ValidationObserver, extend } from 'vee-validate'
import * as rules from 'vee-validate/dist/rules'
import th from 'vee-validate/dist/locale/th.json'

Object.keys(rules).forEach((rule) => {
  extend(rule, {
    ...rules[rule],
    message: th.messages[rule]
  })
})

extend('selection_required', {
  ...rules.required,
  message: 'กรุณาเลือก {_field_}'
})

Vue.component('ValidationProvider', ValidationProvider)
Vue.component('ValidationObserver', ValidationObserver)
